var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 8H12C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12V40H32.4667C35.408 37.0573 37.0573 35.408 40 32.4667V12C40 10.9391 39.5786 9.92172 38.8284 9.17157C38.0783 8.42143 37.0609 8 36 8V8ZM10.6667 12C10.6667 11.6464 10.8071 11.3072 11.0572 11.0572C11.3072 10.8071 11.6464 10.6667 12 10.6667H36C36.3536 10.6667 36.6928 10.8071 36.9428 11.0572C37.1929 11.3072 37.3333 11.6464 37.3333 12V29.3333H29.3333V37.3333H10.6667V12ZM32 36.6947V32H36.6947L32 36.6947Z",
    fill: "#FEF335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 14.6758L13.5278 22.9172H15.3118L15.9998 21.0985H18.7318L19.4172 22.9158H21.1998L18.0878 14.6665L16.6665 14.6758ZM16.6398 19.4318L17.3745 17.5025L18.1025 19.4318H16.6398Z",
    fill: "#FEF335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5412 14.7495H22.8745V22.8415H24.5412V14.7495Z",
    fill: "#FEF335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.879b45f87f3ef5559bc51cf0816d70d4.svg";
export { ForwardRef as ReactComponent };